import { IAPIRoutes } from "../../../../config";

export type IAppPerformanceSurveyRepository = ReturnType<
  typeof AppPerformanceSurveyRepositoryFactory
>;

// API request/response types
type IApiPostAppPerformanceSurveyRequest = {
  comment: string;
  score: number;
  person_properties: {
    facility: string;
    name: string; // userName (full name)
  };
};

type IApiPostAppPerformanceSurveyResponse = {
  success: boolean;
  message?: string;
  data?: unknown;
  survey_response?: unknown;
};

type IApiPostAppPerformanceSurvey = (
  payload: IApiPostAppPerformanceSurveyRequest
) => Promise<IApiPostAppPerformanceSurveyResponse>;

/**
 * AppPerformance Survey Repository
 *
 * This repository handles submitting survey responses to the internal API endpoint
 * (/patient-centric-app-v2/delighted/nps)
 */
export const AppPerformanceSurveyRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const apiPostAppPerformanceSurvey: IApiPostAppPerformanceSurvey = async (
    payload: IApiPostAppPerformanceSurveyRequest
  ) => {
    try {
      const response = await POST(
        APIRoutes.apiPostAppPerformanceSurvey,
        payload,
        {
          Authorization: `Bearer ${await getAuthenticationToken()}`,
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      console.error("Failed to submit to internal API:", error);
      throw error;
    }
  };

  return {
    apiPostAppPerformanceSurvey,
  };
};
